import React, { useEffect, useState } from "react";
import { useIsClient } from "hooks";
import { WpPostTypeSeo } from "codegen";
import { Helmet } from "react-helmet";

interface SEOProps {
  title: string;
  seo: WpPostTypeSeo;
  siteTitle: string;
}

/**
 * SEO component for fun times
 *
 * @param title Option for a custom page title. Setting in Yoast will be preferred though
 * @param seo Data passed from Yoast to be passed in head
 * @returns Helmet component to insert SEO data into header
 *
 */
export const SEO = ({ title = "", seo = null }: SEOProps): JSX.Element => {
  if (!seo) return null;
  return (
    <Helmet title={seo?.opengraphTitle || title}>
      <html lang="en" />
      <meta name="description" content={seo?.metaDesc} />
      <link
        rel="canonical"
        href={seo?.canonical.replace(process.env.GATSBY_WP_ADDRESS, process.env.GATSBY_APP_ADDRESS)}
      />
      <meta name="robots" content={`${seo?.metaRobotsNoindex}, ${seo?.metaRobotsNofollow}`} />
      <meta property="type" content={seo?.opengraphType} />
      <meta property="og:title" content={seo?.opengraphTitle} />
      <meta property="og:description" content={seo?.opengraphDescription} />
      <meta
        property="og:url"
        content={seo?.opengraphUrl.replace(process.env.GATSBY_WP_ADDRESS, process.env.GATSBY_APP_ADDRESS)}
      />
      <meta property="og:site_name" content={seo?.opengraphSiteName} />
      <meta property="article:publisher" content={seo?.opengraphPublisher} />
      <meta property="article:modified_time" content={seo?.opengraphModifiedTime} />
      <meta property="og:image" content={seo?.opengraphImage?.sourceUrl} />
      <meta property="og:image:width" content={seo?.opengraphImage?.width.toString()} />
      <meta property="og:image:height" content={seo?.opengraphImage?.height.toString()} />
      <meta property="og:image:type" content={seo?.opengraphImage?.mimeType} />
      <script type="application/ld+json">{seo?.schema?.raw}</script>
    </Helmet>
  );
};
